/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConsultationBaseService } from '../consultation-base-service';
import { ConsultationApiConfiguration } from '../consultation-api-configuration';
import { ConsultationStrictHttpResponse } from '../consultation-strict-http-response';

import { medicationPost } from '../fn/medication/medication-post';
import { MedicationPost$Params } from '../fn/medication/medication-post';
import { MedicationRequestModel } from '../models/medication-request-model';
import { medicationRequestsEncounterFhirIdGet } from '../fn/medication/medication-requests-encounter-fhir-id-get';
import { MedicationRequestsEncounterFhirIdGet$Params } from '../fn/medication/medication-requests-encounter-fhir-id-get';

@Injectable({ providedIn: 'root' })
export class ConsultationMedicationService extends ConsultationBaseService {
  constructor(config: ConsultationApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `medicationPost()` */
  static readonly MedicationPostPath = '/Medication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicationPost$Response(params?: MedicationPost$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<string>> {
    return medicationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicationPost(params?: MedicationPost$Params, context?: HttpContext): Observable<string> {
    return this.medicationPost$Response(params, context).pipe(
      map((r: ConsultationStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `medicationRequestsEncounterFhirIdGet()` */
  static readonly MedicationRequestsEncounterFhirIdGetPath = '/Medication/Requests/{encounterFHIRId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicationRequestsEncounterFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicationRequestsEncounterFhirIdGet$Response(params: MedicationRequestsEncounterFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<Array<MedicationRequestModel>>> {
    return medicationRequestsEncounterFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicationRequestsEncounterFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicationRequestsEncounterFhirIdGet(params: MedicationRequestsEncounterFhirIdGet$Params, context?: HttpContext): Observable<Array<MedicationRequestModel>> {
    return this.medicationRequestsEncounterFhirIdGet$Response(params, context).pipe(
      map((r: ConsultationStrictHttpResponse<Array<MedicationRequestModel>>): Array<MedicationRequestModel> => r.body)
    );
  }

}
